<template>
  <div style="padding: 20px;">
    <p
      class="filtro font-weight-bold"
      v-if="query.length"
    >Filtros:</p>
    <div
      v-for="q in query"
      :key="q.title"
    >
      <p
        class="filtro"
        v-if="q"
      >
        {{q.title}}: {{q.data}}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    query: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style scoped>
.filtro {
  color: #1e398d;
  margin-left: 20px;
  margin-bottom: 0;
}
</style>
